import React, { useRef } from "react";
import PropTypes from "prop-types";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import { useWatch } from "react-hook-form";

function InTimePicker({
  name,
  record,
  handleTimeChange,
  isApproved = false,
  isReviewed = false,
  isFullPaidLeave = false,
  isAlternateDayOff = false,
}) {
  const inTime = useWatch({ name: `attendance[${record.id}][${name}]` });

  const selectAllText = (e) => {
    if (e.target && e.target.select) {
      e.target.select();
    }
  };

  const handleInput = (e) => {
    const allowed = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ":",
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ];
    if (!allowed.includes(e.key)) {
      e.preventDefault(); // block unwanted keys
    } else {
      let value = e.target.value.replace(/[^0-9]/g, "");
      if (value.length >= 3) {
        value = value.slice(0, 2) + ":" + value.slice(2, 4);
      }
      e.target.value = value;
    }
  };

  const handleKeyDown = (e) => {
    let [hh, mm] = e.target.value.split(":");
    hh = Math.min(parseInt(hh || "0", 10), 23);
    mm = Math.min(parseInt(mm || "0", 10), 59);
    const corrected = `${String(hh).padStart(2, "0")}:${String(mm).padStart(
      2,
      "0",
    )}`;
    e.target.value = corrected;

    handleTimeChange({
      type: name,
      id: record.id,
      value: `${corrected}:00`,
    });
  };

  const onChange = (time) => {
    const fullTimeString = time ? time.format("HH:mm") : null;
    handleTimeChange({
      type: name,
      id: record.id,
      value: fullTimeString,
    });
  };

  const onInput = (e) => {
  };
  return (
    <TimePicker
      value={inTime ? dayjs(inTime, "HH:mm") : null}
      format="HH:mm"
      variant="borderless"
      allowClear={false}
      disabled={
        isApproved ||
        isReviewed ||
        isFullPaidLeave ||
        // isAlternateDayOff ||
        // (name !== "inTime" && isAlternateDayOff) ||
        (name === "outTime" &&
          (record.inTime === "00:00" || record.inTime === "00:00:00"))
      }
      style={{ width: "80px" }}
      onMouseEnter={selectAllText}
      onFocus={selectAllText}
      onClick={selectAllText}
      onKeyDown={handleInput}
      // onKeyDown={(e) => {

      //   console.log("Key pressed:", e.key);
      // }}
      onChange={onChange} // final correction + save
      onInput={onInput}
    />
  );
}

InTimePicker.propTypes = {
  name: PropTypes.oneOf(["inTime", "outTime", "waitingTime", "wtrot"])
    .isRequired,
  record: PropTypes.object.isRequired,
  handleTimeChange: PropTypes.func.isRequired,
  isApproved: PropTypes.bool,
  isReviewed: PropTypes.bool,
  isFullPaidLeave: PropTypes.bool,
  isAlternateDayOff: PropTypes.bool,
};

InTimePicker.displayName = "InTimePicker";

export default React.memo(InTimePicker);
